import React from "react";
import SlidingCarousel from "../SlidingCarousel/SlidingCarousel";
import MeSummary from "./MeSummary"
import "./MeStuff.css"; 


// By extending the React.Component class, TextArea inherits functionality from it
class MeStuff extends React.Component 
{

    constructor(props)
    {

    	/* We MUST call the parent class contructor and send it the props object */
    	super(props);

	    // Setting the initial state of the TextArea component
	    this.state = 
	    {
	        contents: this.props.value
		};
		
	} // End of constructor()
	
    // The render method returns the JSX that should be rendered
	render() 
	{
	    return (

		<div className="MeStuffMain">	
                <h1 className='text-center'>About Me</h1>	
                
				<SlidingCarousel
                componentArray=
				{
					[
						<MeSummary/>
					]
				}
				/>

	    	</div>

	    )
	}

}; // End of class MeStuff 

export default MeStuff;


// WEBPACK FOOTER //
// ./src/components/AboutMe/MeStuff.js